export default {
  'vezapodorysy2NP': {
    viewBox: '0 0 1274 1215',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '497.000 1181.000, 808.000 1181.000, 809.000 1082.000, 793.000 1082.000, 790.000 748.000, 516.000 747.000, 512.000 1083.000, 497.000 1082.000',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/veza-apartman-2np-1/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-1/',
      },
      {
        points:
          '777.000 619.000, 1118.000 618.000, 1119.000 627.000, 1227.000 627.000, 1227.000 781.000, 1115.000 782.000, 1114.000 944.000, 1144.000 945.000, 1144.000 1130.000, 934.000 1129.000, 935.000 1101.000, 776.000 1102.000',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-2nd-floor-2/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-2/',
      },
      {
        points:
          '134.000 1130.000, 372.000 1130.000, 371.000 1102.000, 529.000 1103.000, 529.000 619.000, 161.000 619.000, 160.000 627.000, 52.000 627.000, 52.000 781.000, 165.000 782.000, 165.000 946.000, 134.000 945.000',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-2nd-floor-3/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-3/',
      },
      {
        points:
          '111.000 625.000, 529.000 626.000, 528.000 483.000, 524.000 483.000, 524.000 439.000, 373.000 440.000, 373.000 106.000, 370.000 106.000, 372.000 64.000, 134.000 64.000, 135.000 249.000, 165.000 249.000, 165.000 482.000, 111.000 481.000',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-2nd-floor-4/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-4/',
      },
      {
        points:
          '497.000 12.000, 653.000 12.000, 652.000 498.000, 515.000 498.000, 515.000 456.000, 364.000 456.000, 364.000 88.000, 370.000 88.000, 371.000 92.000, 497.000 92.000, 498.000 89.000',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-2nd-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-5/',
      },
      {
        points:
          '653.000 13.000, 809.000 12.000, 808.000 91.000, 941.000 91.000, 941.000 455.000, 819.000 455.000, 819.000 482.020, 789.980 482.020, 789.980 499.030, 652.000 499.030',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-2nd-floor-6/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-6/',
      },
      {
        points:
          '934.000 64.000, 1144.000 64.000, 1144.000 249.000, 1113.980 249.000, 1113.980 481.000, 1168.000 481.000, 1168.000 626.000, 776.990 626.000, 776.990 499.000, 776.990 482.970, 781.000 482.970, 781.000 439.990, 933.000 439.990',
        pdf: 'https://centraljasna.sk/veza-apartman-2np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-2nd-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-2-pietro-7/',
      },
    ],
  },
  'vezapodorysy3NP': {
    viewBox: '0 0 1175 1213',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '598.000 1174.000, 598.000 748.000, 464.000 748.000, 463.000 763.000, 440.000 763.000, 439.000 790.000, 314.000 790.000, 314.000 1100.000, 320.000 1100.000, 321.000 1095.000, 446.000 1096.000, 446.000 1174.000',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-1-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-1-2/',
      },
      {
        points:
          '751.000 1173.000, 751.000 1096.000, 875.000 1095.000, 875.000 1099.000, 880.000 1099.000, 882.000 790.000, 757.000 790.000, 757.000 764.000, 732.980 764.000, 732.980 747.000, 598.000 747.000, 598.000 1173.000',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-2-2/',
      },
      {
        points:
          '874.000 1123.000, 1081.000 1123.000, 1081.000 942.000, 1051.000 942.000, 1051.000 764.000, 1103.000 764.000, 1103.000 626.000, 719.990 626.000, 719.990 747.000, 719.990 763.030, 719.990 772.000, 748.020 772.000, 748.020 798.170, 873.000 798.170',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-3-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-3-2/',
      },
      {
        points:
          '67.000 625.000, 477.000 625.000, 477.000 771.000, 447.980 771.000, 447.980 797.020, 323.980 797.020, 322.000 1123.000, 90.000 1123.000, 91.000 942.000, 120.000 943.000, 120.000 764.000, 76.000 763.000, 76.000 765.000, 66.000 765.000',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-4-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-4-2/',
      },
      {
        points:
          '322.000 78.000, 323.000 446.000, 472.000 446.000, 472.000 489.000, 477.000 489.000, 477.000 626.000, 67.000 626.000, 66.000 487.000, 119.000 488.000, 119.000 259.000, 90.000 259.000, 90.000 78.000',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-5-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-5-2/',
      },
      {
        points:
          '598.000 27.000, 598.000 504.000, 463.000 504.000, 463.000 462.000, 314.000 462.000, 314.000 104.990, 445.000 104.990, 446.000 27.000',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-6-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-6-2/',
      },
      {
        points:
          '751.000 27.000, 750.000 106.000, 878.000 106.000, 878.000 462.020, 761.000 462.020, 761.000 488.000, 732.980 488.000, 732.980 505.000, 598.000 505.000, 598.000 27.000',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-7-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-7/',
      },
      {
        points:
          '874.000 78.000, 1080.000 77.000, 1080.000 259.000, 1051.000 259.000, 1051.000 489.000, 1103.000 487.000, 1103.000 626.000, 720.000 626.000, 720.000 489.000, 724.120 489.000, 724.120 452.990, 873.000 452.990',
        pdf: 'https://centraljasna.sk/veza-apartman-3np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-8-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-8-2/',
      },
    ],
  },
  'vezapodorysy4NP': {
    viewBox: '0 0 1151 1218',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '586.000 1181.000, 586.000 756.000, 464.000 755.000, 464.000 753.000, 451.000 753.000, 451.000 771.000, 451.000 798.020, 303.000 798.020, 303.000 1015.000, 303.000 1107.000, 308.000 1107.000, 309.000 1103.000, 434.000 1103.000, 434.000 1181.000',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-1-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-1-2/',
      },
      {
        points:
          '586.000 756.000, 708.000 755.000, 708.000 753.000, 721.000 753.000, 721.000 771.000, 744.020 771.000, 744.020 798.020, 870.000 798.020, 870.000 1107.010, 864.000 1107.010, 864.000 1102.880, 739.000 1102.880, 738.000 1105.000, 738.000 1182.000, 586.000 1182.000',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-2-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-2-2/',
      },
      {
        points:
          '862.000 1131.000, 1068.000 1131.000, 1068.000 950.000, 1039.000 950.000, 1039.000 772.000, 1082.000 772.000, 1084.000 773.000, 1091.000 773.000, 1091.000 634.000, 708.000 634.000, 708.000 755.000, 708.000 771.000, 708.000 779.000, 735.020 779.000, 735.020 805.020, 860.000 805.020',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-3-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-3/',
      },
      {
        points:
          '54.000 633.000, 464.000 633.000, 464.000 813.000, 312.000 813.000, 310.000 1131.000, 78.000 1131.000, 78.000 950.000, 108.000 951.000, 108.000 772.000, 64.000 771.000, 64.000 773.000, 55.000 773.000',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-4-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-4/',
      },
      {
        points:
          '55.000 633.000, 464.000 633.000, 464.000 497.000, 459.880 497.000, 459.880 455.000, 311.000 455.000, 311.000 133.000, 307.840 133.000, 310.000 86.000, 78.000 86.000, 78.000 267.000, 108.000 267.000, 107.000 496.000, 55.000 495.000',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-5-2/',
      },
      {
        points:
          '586.000 35.000, 586.000 512.000, 464.000 512.000, 451.000 512.000, 451.000 469.990, 302.000 469.990, 302.000 113.990, 433.000 113.990, 433.000 34.990',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-6-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-6/',
      },
      {
        points:
          '721.000 512.000, 586.000 512.000, 586.000 35.000, 739.000 35.000, 738.000 112.000, 739.000 114.000, 864.000 114.000, 870.000 114.000, 870.000 470.000, 749.000 470.000, 749.000 496.000, 721.980 496.000',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-7-2/',
      },
      {
        points:
          '1092.000 634.000, 708.000 634.000, 708.000 512.000, 708.000 496.970, 713.000 496.970, 713.000 454.000, 860.000 454.000, 860.000 127.990, 863.000 127.000, 862.000 86.000, 1068.000 86.000, 1068.000 267.000, 1039.000 267.000, 1039.000 496.000, 1082.000 496.000, 1082.000 494.000, 1092.000 494.000, 1092.000 504.000, 1091.000 504.000, 1090.000 629.000, 1092.000 629.000',
        pdf: 'https://centraljasna.sk/veza-apartman-4np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-8-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-8/',
      },
    ],
  },
  'vezapodorysy5NP': {
    viewBox: '0 0 1225 1225',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '489.000 1193.000, 645.000 1193.000, 645.000 759.000, 521.000 759.000, 521.000 755.840, 507.000 755.840, 507.000 765.000, 439.000 765.000, 439.000 894.000, 355.000 894.000, 355.000 1117.020, 363.000 1117.020, 363.000 1112.880, 489.000 1112.880, 489.000 1115.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-1-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-1-2/',
      },
      {
        points:
          '644.000 1193.000, 644.000 758.000, 769.000 758.000, 769.000 756.000, 782.000 756.000, 782.000 765.000, 850.000 765.000, 850.000 894.000, 934.000 894.000, 934.000 1023.000, 934.000 1112.020, 801.000 1112.020, 800.000 1115.000, 800.000 1193.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-2-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-2-2/',
      },
      {
        points:
          '926.000 1142.000, 926.000 1132.000, 925.000 903.000, 830.000 903.000, 831.000 774.000, 768.000 774.000, 769.000 632.000, 1160.010 632.000, 1160.010 776.000, 1151.000 776.000, 1150.000 774.000, 1106.000 775.000, 1106.000 957.000, 1136.000 957.000, 1136.000 1141.000, 1127.000 1141.000, 935.000 1141.000, 935.000 1142.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5th-floor-3/',
        pl: 'https://centraljasna.sk/pl/apartament-5-pietro-3/',
      },
      {
        points:
          '363.000 1141.000, 365.000 904.000, 458.000 903.000, 459.000 775.000, 521.000 774.000, 521.000 634.000, 103.000 634.000, 103.000 776.000, 112.000 776.000, 112.000 775.000, 156.000 775.000, 156.000 957.000, 136.000 957.000, 136.000 956.000, 126.000 956.000, 126.000 1142.000, 136.000 1142.000, 136.000 1141.000, 353.000 1141.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5th-floor-4/',
        pl: 'https://centraljasna.sk/pl/apartament-5-pietro-4/',
      },
      {
        points:
          '363.000 75.000, 362.000 100.000, 362.000 117.000, 364.000 118.000, 364.000 322.000, 459.000 322.000, 459.000 494.000, 523.010 494.000, 524.000 510.000, 520.000 510.000, 520.000 634.000, 103.000 634.000, 103.000 493.000, 156.000 493.000, 156.000 260.000, 136.000 260.000, 136.000 261.000, 126.000 261.000, 126.000 75.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5th-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-5-pietro-5/',
      },
      {
        points:
          '489.000 24.000, 645.000 24.000, 645.000 510.000, 521.000 510.000, 507.000 510.000, 507.000 504.000, 449.990 504.000, 449.990 331.000, 356.000 331.000, 356.000 194.000, 356.000 103.950, 489.000 103.950, 490.000 102.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-6-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-6-2/',
      },
      {
        points:
          '801.000 24.000, 800.000 101.000, 801.000 103.000, 927.000 103.000, 933.080 103.000, 934.000 194.000, 934.000 332.000, 840.000 332.000, 840.000 353.020, 840.000 504.000, 783.000 504.000, 783.000 509.100, 645.000 509.100, 645.000 24.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-7/',
      },
      {
        points:
          '769.000 632.000, 1160.000 632.000, 1160.000 493.000, 1106.000 494.000, 1106.000 259.000, 1136.000 260.000, 1136.000 75.000, 926.000 75.000, 927.000 99.000, 927.000 117.000, 925.000 118.000, 925.000 322.000, 831.000 322.000, 831.000 494.000, 769.000 494.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-5np-8/',
        pl: 'https://centraljasna.sk/pl/apartament-5-pietro-8/',
      },
    ],
  },
  'vezapodorysy6NP': {
    viewBox: '0 0 1137 1226',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '80.000 655.000, 80.000 703.000, 87.000 703.000, 87.000 786.010, 85.000 786.010, 85.000 998.000, 87.000 998.000, 87.000 1040.000, 83.000 1040.000, 83.000 1070.000, 113.020 1070.000, 113.020 1065.000, 267.000 1065.000, 267.000 1140.000, 299.000 1140.000, 299.000 1134.000, 412.000 1134.000, 412.000 1137.000, 458.000 1137.000, 458.000 1134.000, 575.000 1134.000, 575.000 710.000, 458.980 710.000, 458.980 655.000',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-1-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-1-2/',
      },
      {
        points:
          '575.000 1133.000, 692.000 1133.000, 692.000 1137.120, 737.010 1137.120, 737.010 1133.850, 851.000 1133.850, 851.000 1140.000, 883.000 1140.000, 883.000 1063.990, 1010.000 1063.990, 1010.000 1070.000, 1040.000 1070.000, 1040.000 1040.000, 1034.900 1040.000, 1034.900 997.990, 1038.000 997.990, 1038.000 785.000, 1036.000 785.000, 1036.000 702.990, 1042.000 702.990, 1042.000 655.990, 711.000 655.990, 711.000 710.150, 575.000 710.150',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-2-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-2-2/',
      },
      {
        points:
          '575.000 124.000, 575.000 610.000, 537.000 610.000, 537.000 709.000, 460.000 709.000, 460.000 655.000, 81.000 655.000, 81.000 606.990, 86.100 606.990, 86.100 524.000, 83.770 524.000, 83.770 261.000, 87.150 261.000, 87.150 218.000, 83.000 218.000, 83.000 188.000, 113.000 188.000, 113.000 193.000, 266.000 193.000, 266.000 117.990, 299.000 117.990, 299.000 125.000, 412.000 125.000, 412.000 120.000, 453.010 120.000, 453.010 125.100',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-6-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-6-2/',
      },
      {
        points:
          '1043.000 656.000, 1043.000 607.000, 1035.930 607.000, 1035.930 524.990, 1039.000 525.000, 1039.000 260.000, 1036.000 260.000, 1036.000 218.000, 1040.000 218.000, 1040.000 188.000, 1010.000 188.000, 1010.000 192.000, 884.000 192.000, 884.000 116.990, 850.000 116.990, 850.000 124.000, 738.000 124.000, 738.000 120.000, 696.000 120.000, 696.000 124.000, 575.000 124.000, 575.000 609.000, 613.000 609.000, 613.000 659.000, 690.000 659.000, 690.000 655.840',
        pdf: 'https://centraljasna.sk/veza-apartman-5-6np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-7/',
      },
    ],
  },
  '3NP': {
    viewBox: '0 0 1505 927',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '151.000 482.000, 151.000 600.000, 120.000 600.000, 119.000 623.000, 70.000 623.000, 70.000 603.000, 45.000 604.000, 45.000 594.000, 23.000 593.000, 23.000 545.000, 46.000 544.000, 46.000 479.000, 50.000 479.000, 50.000 481.000, 151.000 480.000',
        pdf: 'https://centraljasna.sk/apartman-3np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-1/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-1/',
      },
      {
        points:
          '151.000 481.000, 253.000 481.000, 252.000 601.000, 245.000 600.000, 219.000 600.000, 219.000 623.000, 170.000 623.000, 170.000 600.000, 151.000 599.000',
        pdf: 'https://centraljasna.sk/apartman-3np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-2/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-2/',
      },
      {
        points:
          '151.000 328.000, 151.000 448.000, 50.000 447.000, 50.000 449.000, 46.000 449.000, 45.000 384.000, 23.000 384.000, 22.000 334.000, 45.000 334.000, 45.000 325.000, 70.000 324.000, 70.000 304.000, 119.000 305.000, 119.000 328.000',
        pdf: 'https://centraljasna.sk/apartman-3np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-3/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-3/',
      },
      {
        points:
          '151.000 328.000, 170.000 328.000, 171.000 304.000, 219.000 305.000, 219.000 328.000, 250.000 327.000, 252.000 335.000, 252.000 448.000, 151.000 448.000',
        pdf: 'https://centraljasna.sk/apartman-3np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-4/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-4/',
      },
      {
        points:
          '404.000 194.000, 328.000 194.000, 327.000 156.000, 245.000 155.000, 245.000 149.000, 240.000 148.000, 240.000 123.000, 241.000 112.000, 242.000 96.000, 245.000 96.000, 245.000 91.000, 242.000 90.000, 242.000 76.000, 244.000 76.000, 244.000 71.000, 242.000 71.000, 242.000 47.000, 244.000 46.000, 244.000 25.000, 246.000 22.000, 401.000 22.000, 404.000 24.000, 403.000 46.000, 405.000 47.000, 405.000 71.000, 403.000 71.000, 403.000 76.000, 406.000 76.000, 405.000 91.000, 403.000 91.000, 403.000 96.000, 406.000 96.000, 406.000 111.000, 405.000 112.000, 404.000 134.000, 407.000 134.000, 408.000 155.000, 407.000 156.000, 403.000 156.000',
        pdf: 'https://centraljasna.sk/apartman-3np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-5/',
      },
      {
        points:
          '366.000 293.000, 245.000 293.000, 245.000 265.000, 221.000 264.000, 221.000 214.000, 245.000 215.000, 245.000 198.000, 222.000 198.000, 221.000 148.000, 245.000 149.000, 245.000 153.000, 331.000 153.000, 331.000 190.000, 366.000 190.000',
        pdf: 'https://centraljasna.sk/apartman-3np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-6/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-6/',
      },
      {
        points:
          '250.000 548.000, 366.000 548.000, 366.000 637.000, 245.000 638.000, 245.000 641.000, 226.000 641.000, 226.000 603.000, 246.000 602.000, 247.000 594.000, 249.000 594.000',
        pdf: 'https://centraljasna.sk/apartman-3np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-7/',
      },
      {
        points:
          '245.000 635.000, 366.000 635.000, 366.000 737.000, 331.000 738.000, 330.000 776.000, 245.000 775.000, 244.000 779.000, 241.000 780.000, 222.000 780.000, 221.000 730.000, 245.000 730.000, 245.000 713.000, 221.000 713.000, 222.000 664.000, 245.000 664.000',
        pdf: 'https://centraljasna.sk/apartman-3np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-8/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-8/',
      },
      {
        points:
          '328.000 735.000, 404.000 734.000, 404.000 798.000, 407.000 798.000, 407.000 818.000, 405.000 817.000, 406.000 832.000, 402.000 832.000, 403.000 837.000, 406.000 837.000, 406.000 853.000, 403.000 853.000, 402.000 856.000, 405.000 857.000, 405.000 881.000, 403.000 882.000, 403.000 905.000, 245.000 904.000, 244.000 882.000, 242.000 881.000, 242.000 857.000, 245.000 856.000, 245.000 853.000, 242.000 853.000, 242.000 837.000, 245.000 837.000, 245.000 832.000, 242.000 832.000, 242.000 817.000, 240.000 817.000, 240.000 779.000, 245.000 779.000, 245.000 771.000, 328.000 772.000',
        pdf: 'https://centraljasna.sk/apartman-3np-9/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-9/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-9/',
      },
      {
        points:
          '395.000 447.000, 532.000 447.000, 532.000 328.000, 521.000 328.000, 521.000 305.000, 473.000 304.000, 472.000 328.000, 455.000 327.000, 455.000 305.000, 406.000 305.000, 405.000 327.000, 395.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-3np-10/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-10/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-10/',
      },
      {
        points:
          '529.000 447.000, 528.000 328.000, 538.000 328.000, 538.000 305.000, 588.000 305.000, 588.000 328.000, 605.000 328.000, 606.000 304.000, 655.000 305.000, 655.000 328.000, 665.000 328.000, 665.000 448.000',
        pdf: 'https://centraljasna.sk/apartman-3np-11/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-11/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-11/',
      },
      {
        points:
          '405.000 623.000, 455.000 623.000, 455.000 600.000, 472.000 600.000, 472.000 623.000, 521.000 623.000, 521.000 600.000, 532.000 600.000, 531.000 481.000, 395.000 481.000, 395.000 616.000, 405.000 616.000',
        pdf: 'https://centraljasna.sk/apartman-3np-12/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-12/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-12/',
      },
      {
        points:
          '529.000 481.000, 665.000 481.000, 665.000 600.000, 655.000 600.000, 655.000 623.000, 605.000 623.000, 605.000 600.000, 588.000 600.000, 588.000 623.000, 538.000 623.000, 539.000 600.000, 529.000 600.000',
        pdf: 'https://centraljasna.sk/apartman-3np-13/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-13/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-13/',
      },
      {
        points:
          '660.000 600.000, 673.000 600.000, 673.000 604.000, 719.000 603.000, 724.000 601.000, 732.000 600.000, 732.000 481.000, 660.000 481.000',
        pdf: 'https://centraljasna.sk/apartman-3np-14/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-14/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-14/',
      },
      {
        points:
          '806.000 193.000, 882.000 194.000, 883.000 156.000, 886.000 156.000, 885.000 134.000, 883.000 134.000, 883.000 113.000, 885.000 113.000, 884.000 96.000, 882.000 96.000, 881.000 90.000, 884.000 90.000, 884.000 76.000, 881.000 76.000, 881.000 70.000, 884.000 70.000, 884.000 47.000, 882.000 46.000, 882.000 24.000, 879.000 22.000, 726.000 22.000, 723.000 25.000, 723.000 46.000, 721.000 47.000, 721.000 70.000, 723.000 70.000, 724.000 76.000, 721.000 76.000, 721.000 90.000, 724.000 90.000, 724.000 96.000, 721.000 96.000, 721.000 113.000, 722.000 113.000, 722.000 125.000, 720.000 125.000, 720.000 134.000, 718.000 134.000, 719.000 147.000, 720.000 148.000, 724.000 148.000, 724.000 156.000, 727.000 156.000, 728.000 155.000, 806.000 156.000',
        pdf: 'https://centraljasna.sk/apartman-3np-15/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-15/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-15/',
      },
      {
        points:
          '845.000 294.000, 727.000 294.000, 724.000 295.000, 723.000 264.000, 700.000 264.000, 700.000 214.000, 723.000 214.000, 724.000 197.000, 700.000 197.000, 700.000 148.000, 724.000 149.000, 723.000 156.000, 726.000 157.000, 728.000 156.000, 732.000 153.000, 809.000 153.000, 810.000 190.000, 845.000 190.000',
        pdf: 'https://centraljasna.sk/apartman-3np-16/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-16/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-16/',
      },
      {
        points:
          '662.500 384.000, 662.500 328.500, 673.500 328.500, 673.500 325.500, 721.500 325.500, 721.500 288.000, 725.000 288.000, 725.000 291.500, 845.500 291.500, 845.500 379.000, 732.000 379.000, 732.000 448.000, 660.000 448.000, 660.000 384.000, 662.500 384.000',
        pdf: 'https://centraljasna.sk/apartman-3np-17/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-17/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-17/',
      },
      {
        points:
          '845.000 549.000, 845.000 639.000, 784.000 640.000, 784.000 638.000, 732.000 637.000, 720.000 637.000, 720.000 604.000, 727.000 601.000, 729.000 594.000, 729.000 549.000',
        pdf: 'https://centraljasna.sk/apartman-3np-18/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-18/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-18/',
      },
      {
        points:
          '727.000 634.000, 845.000 634.000, 845.000 659.000, 879.000 658.000, 882.000 658.000, 883.000 666.000, 879.000 666.000, 879.000 699.000, 886.000 699.000, 885.000 731.000, 884.000 746.000, 881.000 747.000, 881.000 751.000, 884.000 752.000, 884.000 766.000, 881.000 767.000, 882.000 772.000, 884.000 772.000, 885.000 795.000, 882.000 796.000, 882.000 818.000, 880.000 821.000, 725.000 820.000, 723.000 817.000, 723.000 796.000, 721.000 795.000, 721.000 772.000, 724.000 772.000, 724.000 767.000, 721.000 766.000, 721.000 752.000, 724.000 752.000, 724.000 747.000, 721.000 746.000, 721.000 729.000, 719.000 728.000, 719.000 697.000, 700.000 697.000, 700.000 647.000, 720.000 647.000, 720.000 641.000',
        pdf: 'https://centraljasna.sk/apartman-3np-19/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/apartment-3rd-floor-19/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-19/',
      },
      {
        points:
          '944.000 335.000, 944.000 448.000, 874.000 447.000, 874.000 312.000, 884.000 311.000, 884.000 305.000, 933.000 305.000, 934.000 328.000, 944.000 328.000',
        pdf: 'https://centraljasna.sk/apartman-3np-20/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-20/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-20/',
      },
      {
        points:
          '1076.000 328.000, 1076.000 448.000, 941.000 448.000, 941.000 328.000, 951.000 328.000, 951.000 305.000, 1000.000 305.000, 1000.000 328.000, 1017.000 328.000, 1018.000 305.000, 1067.000 305.000, 1067.000 328.000',
        pdf: 'https://centraljasna.sk/apartman-3np-21/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-21/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-21/',
      },
      {
        points:
          '1074.000 448.000, 1210.000 448.000, 1210.000 312.000, 1201.000 312.000, 1200.000 305.000, 1151.000 305.000, 1151.000 328.000, 1134.000 328.000, 1133.000 305.000, 1085.000 305.000, 1084.000 328.000, 1074.000 328.000',
        pdf: 'https://centraljasna.sk/apartman-3np-22/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-22/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-22/',
      },
      {
        points:
          '944.000 545.000, 944.000 623.000, 874.000 624.000, 874.000 481.000, 946.000 481.000',
        pdf: 'https://centraljasna.sk/apartman-3np-23/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-23/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-23/',
      },
      {
        points:
          '941.000 481.000, 941.000 622.000, 942.000 644.000, 949.000 645.000, 949.000 649.000, 997.000 650.000, 997.000 645.000, 1011.000 645.000, 1012.000 649.000, 1073.000 648.000, 1074.000 645.000, 1078.000 645.000, 1076.000 481.000',
        pdf: 'https://centraljasna.sk/apartman-3np-24/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-24/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-24/',
      },
      {
        points:
          '1210.000 481.000, 1210.000 624.000, 1144.000 623.000, 1142.000 644.000, 1136.000 644.000, 1135.000 650.000, 1087.000 649.000, 1087.000 645.000, 1075.000 645.000, 1074.000 481.000',
        pdf: 'https://centraljasna.sk/apartman-3np-25/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-25/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-25/',
      },
      {
        points:
          '1201.000 315.000, 1240.000 315.000, 1240.000 335.000, 1353.000 335.000, 1377.000 335.000, 1377.000 326.000, 1379.000 323.000, 1379.000 277.000, 1365.000 277.000, 1364.000 246.000, 1361.000 243.000, 1361.000 238.000, 1363.000 238.000, 1363.000 223.000, 1361.000 223.000, 1361.000 217.000, 1363.000 217.000, 1363.000 203.000, 1361.000 203.000, 1361.000 197.000, 1363.000 197.000, 1363.000 174.000, 1361.000 174.000, 1361.000 150.000, 1203.000 150.000, 1202.000 173.000, 1200.000 174.000, 1200.000 197.000, 1203.000 197.000, 1203.000 203.000, 1200.000 203.000, 1200.000 217.000, 1203.000 218.000, 1203.000 223.000, 1200.000 223.000, 1200.000 238.000, 1203.000 238.000, 1203.000 243.000, 1200.000 243.000, 1199.000 247.000, 1199.000 277.000, 1202.000 278.000, 1202.000 305.000',
        pdf: 'https://centraljasna.sk/apartman-3np-26/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-26/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-26/',
      },
      {
        points:
          '1240.000 549.000, 1356.000 549.000, 1356.000 594.000, 1362.000 594.000, 1362.000 603.000, 1379.000 603.000, 1379.000 641.000, 1363.000 641.000, 1353.000 638.000, 1301.000 638.000, 1240.000 638.000',
        pdf: 'https://centraljasna.sk/apartman-3np-27/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-27/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-27/',
      },
      {
        points:
          '1361.000 648.000, 1384.000 648.000, 1384.000 696.000, 1365.000 697.000, 1365.000 719.000, 1364.000 729.000, 1364.000 746.000, 1360.000 746.000, 1361.000 752.000, 1364.000 752.000, 1363.000 766.000, 1360.000 766.000, 1360.000 772.000, 1363.000 772.000, 1363.000 795.000, 1361.000 795.000, 1361.000 818.000, 1358.000 820.000, 1204.000 820.000, 1202.000 818.000, 1202.000 796.000, 1200.000 795.000, 1200.000 772.000, 1203.000 772.000, 1203.000 767.000, 1200.000 766.000, 1200.000 752.000, 1203.000 752.000, 1203.000 747.000, 1200.000 746.000, 1200.000 728.000, 1199.000 728.000, 1199.000 699.000, 1202.000 699.000, 1202.000 658.000, 1239.000 659.000, 1240.000 635.000, 1358.000 634.000, 1362.000 634.000',
        pdf: 'https://centraljasna.sk/apartman-3np-28/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-28/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-28/',
      },
      {
        points:
          '1353.000 447.000, 1459.000 447.000, 1460.000 383.000, 1482.000 383.000, 1483.000 335.000, 1460.000 334.000, 1460.000 325.000, 1436.000 325.000, 1435.000 304.000, 1387.000 305.000, 1386.000 327.000, 1353.000 328.000',
        pdf: 'https://centraljasna.sk/apartman-3np-29/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-29/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-29/',
      },
      {
        points:
          '1387.000 623.000, 1436.000 623.000, 1436.000 603.000, 1460.000 603.000, 1459.000 480.000, 1353.000 481.000, 1353.000 600.000, 1386.000 600.000',
        pdf: 'https://centraljasna.sk/apartman-3np-30/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-3rd-floor-30/',
        pl: 'https://centraljasna.sk/pl/apartament-3-pietro-30/',
      },
    ],
  },
  '4NP': {
    viewBox: '0 0 1502 930',
    maxZoom: 1.5,
    apartments: [
      {
        points:
          '43.000 499.000, 149.000 499.000, 149.000 618.000, 116.000 618.000, 116.000 641.000, 68.000 641.000, 67.000 621.000, 42.000 622.000, 42.000 612.000, 21.000 612.000, 20.000 610.000, 19.000 564.000, 22.000 562.000, 42.000 563.000',
        pdf: 'https://centraljasna.sk/apartman-4np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-1/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-1/',
      },
      {
        points:
          '147.000 612.000, 147.000 499.000, 249.000 499.000, 249.000 618.000, 216.000 618.000, 216.000 641.000, 168.000 641.000, 167.000 618.000, 147.000 617.000',
        pdf: 'https://centraljasna.sk/apartman-4np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-2/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-2/',
      },
      {
        points:
          '150.000 424.000, 150.000 466.000, 43.000 466.000, 43.000 402.000, 21.000 402.000, 19.000 400.000, 19.000 353.000, 21.000 352.000, 42.000 352.000, 42.000 343.000, 67.000 343.000, 67.000 323.000, 116.000 323.000, 116.000 346.000, 150.000 346.000',
        pdf: 'https://centraljasna.sk/apartman-4np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-3/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-3/',
      },
      {
        points:
          '146.000 346.000, 146.000 466.000, 250.000 466.000, 250.000 346.000, 217.000 346.000, 217.000 323.000, 167.000 323.000, 167.000 346.000',
        pdf: 'https://centraljasna.sk/apartman-4np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-4/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-4/',
      },
      {
        points:
          '401.000 212.000, 325.500 212.000, 325.500 174.500, 242.500 174.500, 242.500 167.000, 237.500 167.000, 238.500 141.000, 238.500 130.000, 240.000 130.000, 240.000 114.500, 243.000 114.500, 243.000 109.000, 240.000 109.000, 240.000 94.500, 243.000 94.500, 243.000 89.500, 240.000 89.500, 240.000 65.000, 242.000 65.000, 242.000 43.500, 244.000 43.500, 399.000 43.500, 401.000 42.500, 402.500 65.500, 402.500 89.000, 401.000 89.000, 401.000 95.000, 402.500 95.000, 402.500 109.000, 399.500 109.000, 399.500 115.000, 402.500 115.000, 402.500 152.500, 405.500 152.500, 405.500 174.500, 401.000 174.500, 401.000 212.000',
        pdf: 'https://centraljasna.sk/apartman-4np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-5/',
      },
      {
        points:
          '363.500 312.000, 242.500 312.000, 242.500 283.000, 219.000 283.000, 219.000 233.500, 242.500 233.500, 242.500 216.000, 219.000 216.000, 219.000 167.000, 250.000 167.000, 250.000 172.000, 328.500 172.000, 328.500 209.000, 363.500 209.000',
        pdf: 'https://centraljasna.sk/apartman-4np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-6/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-6/',
      },
      {
        points:
          '247.000 567.000, 363.000 567.000, 363.000 655.000, 242.000 656.000, 242.000 659.000, 224.000 659.000, 223.000 621.000, 245.000 620.000, 247.000 612.000',
        pdf: 'https://centraljasna.sk/apartman-4np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-7/',
      },
      {
        points:
          '242.000 653.000, 363.000 653.000, 363.000 756.000, 328.000 756.000, 328.000 794.000, 242.000 794.000, 241.000 797.000, 219.000 798.000, 218.000 748.000, 241.000 748.000, 242.000 731.000, 218.000 731.000, 218.000 682.000, 242.000 682.000',
        pdf: 'https://centraljasna.sk/apartman-4np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-8/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-8/',
      },
      {
        points:
          '242.000 923.000, 401.000 923.000, 400.000 900.000, 403.000 900.000, 403.000 875.000, 400.000 875.000, 400.000 871.000, 403.000 870.000, 403.000 855.000, 399.000 855.000, 400.000 850.000, 402.000 849.000, 403.000 835.000, 403.000 816.000, 401.000 816.000, 402.000 790.000, 401.000 752.000, 325.000 753.000, 325.000 790.000, 242.000 790.000, 241.000 797.000, 238.000 798.000, 237.000 835.000, 239.000 835.000, 239.000 849.000, 242.000 849.000, 242.000 855.000, 239.000 855.000, 239.000 870.000, 241.000 870.000, 242.000 875.000, 239.000 875.000, 239.000 899.000, 241.000 900.000',
        pdf: 'https://centraljasna.sk/apartman-4np-9/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-9/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-9/',
      },
      {
        points:
          '392.000 465.000, 528.000 465.000, 528.000 346.000, 518.000 346.000, 518.000 323.000, 469.000 323.000, 470.000 346.000, 453.000 346.000, 452.000 323.000, 403.000 323.000, 402.000 330.000, 393.000 330.000',
        pdf: 'https://centraljasna.sk/apartman-4np-10/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-10/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-10/',
      },
      {
        points:
          '526.000 346.000, 526.000 466.000, 661.000 465.000, 661.000 346.000, 652.000 346.000, 652.000 323.000, 602.000 322.000, 602.000 346.000, 585.000 346.000, 585.000 322.000, 536.000 323.000, 535.000 346.000',
        pdf: 'https://centraljasna.sk/apartman-4np-11/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-11/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-11/',
      },
      {
        points:
          '528.000 617.000, 528.000 498.000, 392.000 499.000, 392.000 635.000, 402.000 635.000, 402.000 641.000, 452.000 641.000, 452.000 618.000, 469.000 618.000, 469.000 642.000, 518.000 641.000, 518.000 618.000',
        pdf: 'https://centraljasna.sk/apartman-4np-12/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-12/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-12/',
      },
      {
        points:
          '526.000 499.000, 525.000 617.000, 536.000 618.000, 535.000 641.000, 585.000 641.000, 586.000 618.000, 602.000 618.000, 602.000 641.000, 652.000 641.000, 652.000 618.000, 662.000 618.000, 661.000 498.000',
        pdf: 'https://centraljasna.sk/apartman-4np-13/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-13/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-13/',
      },
      {
        points:
          '657.000 499.000, 657.000 618.000, 670.000 618.000, 670.000 621.000, 716.000 622.000, 720.000 618.000, 729.000 618.000, 729.000 499.000',
        pdf: 'https://centraljasna.sk/apartman-4np-14/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-14/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-14/',
      },
      {
        points:
          '803.000 211.000, 880.000 211.000, 880.000 174.000, 882.000 174.000, 883.000 152.000, 881.000 151.000, 881.000 132.000, 882.000 114.000, 879.000 114.000, 878.000 108.000, 882.000 108.000, 881.000 94.000, 878.000 94.000, 878.000 89.000, 881.000 88.000, 881.000 65.000, 879.000 64.000, 879.000 41.000, 877.000 40.000, 722.000 40.000, 720.000 43.000, 720.000 64.000, 718.000 65.000, 718.000 88.000, 721.000 88.000, 721.000 94.000, 718.000 94.000, 718.000 108.000, 721.000 108.000, 721.000 114.000, 718.000 114.000, 718.000 131.000, 719.000 131.000, 719.000 143.000, 717.000 143.000, 717.000 152.000, 716.000 152.000, 716.000 166.000, 721.000 166.000, 721.000 174.000, 723.000 174.000, 729.000 173.000, 803.000 173.000',
        pdf: 'https://centraljasna.sk/apartman-4np-15/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-15/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-15/',
      },
      {
        points:
          '721.000 311.000, 842.000 311.000, 842.000 208.000, 806.000 208.000, 806.000 171.000, 721.000 171.000, 721.000 166.000, 697.000 167.000, 697.000 216.000, 721.000 215.000, 720.000 233.000, 698.000 233.000, 698.000 282.000, 721.000 282.000',
        pdf: 'https://centraljasna.sk/apartman-4np-16/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-16/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-16/',
      },
      {
        points:
          '729.500 397.500, 842.500 397.500, 842.500 309.500, 721.500 309.500, 721.500 305.500, 717.500 305.500, 717.500 344.000, 670.500 344.000, 670.500 346.500, 660.000 346.500, 660.000 401.500, 658.000 401.500, 658.000 466.000, 729.500 466.000, 729.500 397.500',
        pdf: 'https://centraljasna.sk/apartman-4np-17/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-17/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-17/',
      },
      {
        points:
          '717.000 655.000, 842.000 655.000, 842.000 567.000, 726.000 567.000, 726.000 612.000, 716.000 612.000',
        pdf: 'https://centraljasna.sk/apartman-4np-18/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-18/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-18/',
      },
      {
        points:
          '720.000 835.000, 722.000 839.000, 877.000 838.000, 880.000 836.000, 878.000 814.000, 882.000 813.000, 881.000 790.000, 878.000 790.000, 878.000 784.000, 881.000 784.000, 881.000 770.000, 878.000 770.000, 878.000 764.000, 881.000 764.000, 882.000 750.000, 883.000 717.000, 876.000 716.000, 876.000 683.000, 880.000 683.000, 879.000 676.000, 876.000 675.000, 874.000 677.000, 842.000 677.000, 842.000 652.000, 717.000 653.000, 717.000 665.000, 697.000 665.000, 697.000 715.000, 717.000 715.000, 716.000 746.000, 718.000 746.000, 718.000 764.000, 721.000 764.000, 721.000 770.000, 718.000 770.000, 718.000 784.000, 721.000 784.000, 721.000 790.000, 718.000 790.000, 718.000 813.000, 720.000 813.000',
        pdf: 'https://centraljasna.sk/apartman-4np-19/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-19/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-19/',
      },
      {
        points:
          '871.000 330.000, 881.000 330.000, 881.000 322.000, 930.000 323.000, 931.000 345.000, 941.000 346.000, 941.000 466.000, 871.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-4np-20/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-20/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-20/',
      },
      {
        points:
          '938.000 466.000, 1074.000 466.000, 1074.000 346.000, 1064.000 346.000, 1063.000 323.000, 1015.000 323.000, 1014.000 346.000, 997.000 346.000, 997.000 322.000, 948.000 323.000, 947.000 345.000, 938.000 346.000',
        pdf: 'https://centraljasna.sk/apartman-4np-21/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-21/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-21/',
      },
      {
        points:
          '1071.000 346.000, 1071.000 466.000, 1207.000 466.000, 1207.000 330.000, 1197.000 330.000, 1196.000 323.000, 1149.000 323.000, 1148.000 346.000, 1131.000 346.000, 1130.000 323.000, 1082.000 323.000, 1081.000 346.000',
        pdf: 'https://centraljasna.sk/apartman-4np-22/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-22/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-22/',
      },
      {
        points:
          '871.000 499.000, 944.000 498.000, 944.000 562.000, 941.000 563.000, 941.000 639.000, 880.000 639.000, 879.000 643.000, 871.000 643.000',
        pdf: 'https://centraljasna.sk/apartman-4np-23/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-23/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-23/',
      },
      {
        points:
          '939.000 662.000, 946.000 663.000, 994.000 664.000, 994.000 663.000, 1008.000 663.000, 1008.000 664.000, 1070.000 664.000, 1071.000 662.000, 1075.000 662.000, 1073.000 498.000, 938.000 499.000, 938.000 639.000, 941.000 639.000',
        pdf: 'https://centraljasna.sk/apartman-4np-24/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-24/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-24/',
      },
      {
        points:
          '1070.000 499.000, 1070.000 663.000, 1084.000 663.000, 1133.000 663.000, 1140.000 662.000, 1140.000 641.000, 1208.000 642.000, 1207.000 499.000',
        pdf: 'https://centraljasna.sk/apartman-4np-25/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-25/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-25/',
      },
      {
        points:
          '1198.000 330.000, 1199.000 295.000, 1196.000 295.000, 1196.000 265.000, 1197.000 261.000, 1200.000 260.000, 1200.000 257.000, 1197.000 256.000, 1197.000 241.000, 1199.000 241.000, 1200.000 236.000, 1200.000 235.000, 1197.000 235.000, 1197.000 221.000, 1200.000 221.000, 1200.000 216.000, 1197.000 215.000, 1197.000 192.000, 1199.000 191.000, 1199.000 168.000, 1201.000 167.000, 1356.000 167.000, 1358.000 169.000, 1358.000 191.000, 1360.000 192.000, 1360.000 215.000, 1358.000 215.000, 1357.000 220.000, 1360.000 221.000, 1360.000 235.000, 1357.000 235.000, 1357.000 241.000, 1360.000 241.000, 1360.000 256.000, 1357.000 256.000, 1357.000 261.000, 1360.000 261.000, 1360.000 264.000, 1361.000 264.000, 1361.000 294.000, 1375.000 295.000, 1376.000 343.000, 1374.000 345.000, 1373.000 352.000, 1237.000 352.000, 1236.000 333.000, 1207.000 333.000, 1198.000 333.000',
        pdf: 'https://centraljasna.sk/apartman-4np-26/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-26/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-26/',
      },
      {
        points:
          '1236.000 567.000, 1237.000 658.000, 1349.000 656.000, 1358.000 656.000, 1358.000 660.000, 1376.000 659.000, 1375.000 621.000, 1355.000 620.000, 1352.000 619.000, 1352.000 566.000',
        pdf: 'https://centraljasna.sk/apartman-4np-27/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-27/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-27/',
      },
      {
        points:
          '1237.000 653.000, 1358.000 653.000, 1358.000 665.000, 1381.000 666.000, 1380.000 715.000, 1362.000 715.000, 1362.000 737.000, 1361.000 747.000, 1360.000 764.000, 1358.000 764.000, 1357.000 769.000, 1360.000 770.000, 1360.000 784.000, 1358.000 784.000, 1358.000 790.000, 1360.000 790.000, 1360.000 814.000, 1358.000 814.000, 1358.000 837.000, 1355.000 838.000, 1201.000 838.000, 1199.000 836.000, 1199.000 814.000, 1197.000 814.000, 1197.000 790.000, 1200.000 790.000, 1200.000 785.000, 1197.000 784.000, 1197.000 770.000, 1200.000 770.000, 1200.000 764.000, 1197.000 764.000, 1197.000 746.000, 1196.000 746.000, 1196.000 717.000, 1199.000 717.000, 1199.000 677.000, 1237.000 677.000',
        pdf: 'https://centraljasna.sk/apartman-4np-28/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-28/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-28/',
      },
      {
        points:
          '1350.000 465.000, 1456.000 465.000, 1457.000 401.000, 1478.000 402.000, 1480.000 400.000, 1480.000 354.000, 1478.000 352.000, 1458.000 352.000, 1457.000 343.000, 1433.000 343.000, 1433.000 325.000, 1430.000 322.000, 1384.000 322.000, 1383.000 324.000, 1383.000 346.000, 1350.000 347.000',
        pdf: 'https://centraljasna.sk/apartman-4np-29/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-29/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-29/',
      },
      {
        points:
          '1350.000 499.000, 1456.000 498.000, 1457.000 611.000, 1457.000 622.000, 1433.000 622.000, 1432.000 641.000, 1384.000 641.000, 1384.000 618.000, 1350.000 618.000',
        pdf: 'https://centraljasna.sk/apartman-4np-30/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-4th-floor-30/',
        pl: 'https://centraljasna.sk/pl/apartament-4-pietro-30/',
      },
    ],
  },
  '5NP': {
    viewBox: '0 0 1500 914',
    maxZoom: 2.5,
    apartments: [
      {
        points:
          '64.000 616.000, 116.000 616.000, 116.000 592.000, 148.000 592.000, 148.000 471.000, 42.000 471.000, 42.000 536.000, 18.000 536.000, 18.000 587.000, 39.000 587.000, 40.000 595.000, 65.000 595.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-1/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-1/',
      },
      {
        points:
          '145.000 591.000, 145.000 471.000, 249.000 471.000, 249.000 591.000, 216.000 591.000, 217.000 616.000, 165.000 616.000, 166.000 592.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-2/',
      },
      {
        points:
          '149.000 319.000, 149.000 439.000, 42.000 439.000, 42.000 374.000, 18.000 374.000, 18.000 324.000, 40.000 324.000, 40.000 315.000, 65.000 315.000, 65.000 295.000, 115.000 295.000, 115.000 318.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-3/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-3/',
      },
      {
        points:
          '146.000 319.000, 146.000 439.000, 249.000 439.000, 249.000 319.000, 216.000 319.000, 216.000 294.000, 166.000 294.000, 166.000 319.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-4/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-4/',
      },
      {
        points:
          '358.000 136.000, 405.000 136.000, 405.000 123.000, 402.000 123.000, 402.000 101.000, 404.000 101.000, 404.000 69.000, 401.000 69.000, 401.000 63.000, 403.000 63.000, 403.000 49.000, 401.000 49.000, 401.000 42.900, 404.000 42.900, 404.000 34.900, 401.000 34.900, 401.000 11.000, 241.000 11.000, 241.000 35.000, 239.400 36.600, 239.400 43.000, 242.000 43.000, 242.000 49.000, 239.000 49.000, 239.000 63.000, 242.000 63.000, 242.000 69.000, 239.000 69.000, 239.000 102.000, 238.000 102.000, 238.000 112.000, 237.000 112.000, 237.000 128.000, 342.000 128.000, 345.000 130.000, 358.000 130.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-5/',
      },
      {
        points:
          '364.000 125.000, 237.000 125.000, 237.000 137.000, 216.000 137.000, 217.000 140.000, 216.000 188.000, 241.000 187.000, 241.000 198.000, 364.000 198.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-6/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-6/',
      },
      {
        points:
          '241.000 195.000, 364.000 195.000, 364.000 284.000, 241.000 284.000, 241.000 254.000, 217.000 255.000, 217.000 204.000, 241.000 204.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-7/',
      },
      {
        points:
          '247.000 541.000, 364.000 541.000, 364.000 630.000, 250.000 629.000, 241.000 630.000, 241.000 634.000, 222.000 635.000, 223.000 593.000, 245.000 594.000, 247.000 593.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-8/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-8/',
      },
      {
        points:
          '241.000 627.000, 364.000 627.000, 364.000 715.000, 241.000 715.000, 241.000 706.000, 216.000 706.000, 216.000 656.000, 241.000 656.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-9/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-9/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-9/',
      },
      {
        points:
          '241.000 713.000, 363.000 713.000, 363.000 785.000, 238.000 785.000, 238.000 773.000, 217.000 773.000, 217.000 723.000, 241.000 723.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-10/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-10/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-10/',
      },
      {
        points:
          '358.000 774.000, 403.000 774.000, 403.000 791.000, 405.000 791.000, 405.000 810.000, 402.800 810.000, 402.800 841.000, 400.000 841.000, 400.000 846.000, 404.100 846.000, 404.100 861.000, 400.000 861.000, 400.000 867.000, 403.000 867.000, 403.000 874.000, 401.000 874.000, 402.000 900.000, 240.000 900.000, 241.000 875.000, 239.000 874.000, 239.000 867.000, 242.000 867.000, 242.000 861.000, 239.000 861.000, 239.000 847.000, 242.000 847.000, 242.000 842.000, 239.000 841.000, 239.000 810.000, 238.000 810.000, 238.000 783.000, 358.000 782.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-11/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-11/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-11/',
      },
      {
        points:
          '732.000 438.000, 662.000 438.000, 662.000 319.000, 672.000 319.000, 672.000 313.900, 720.000 313.900, 722.000 317.000, 726.000 317.000, 731.000 318.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-12/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-12/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-12/',
      },
      {
        points:
          '665.000 438.000, 665.000 319.000, 654.000 319.000, 654.000 295.000, 604.000 295.000, 604.000 319.000, 594.000 319.000, 594.000 438.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-13/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-13/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-13/',
      },
      {
        points:
          '597.000 319.000, 597.000 439.000, 527.000 439.000, 527.000 319.000, 537.000 319.000, 537.000 295.000, 587.000 295.000, 587.000 319.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-14/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-14/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-14/',
      },
      {
        points:
          '662.000 472.000, 731.000 472.000, 731.000 593.000, 718.000 595.000, 672.000 595.000, 672.000 592.000, 662.000 591.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-15/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-15/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-15/',
      },
      {
        points:
          '665.000 592.000, 665.000 472.000, 595.000 472.000, 595.000 591.000, 604.000 591.000, 604.000 616.000, 654.000 616.000, 654.000 592.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-16/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-16/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-16/',
      },
      {
        points:
          '527.000 472.000, 527.000 592.000, 537.000 592.000, 537.000 616.000, 587.000 616.000, 587.000 591.000, 597.000 591.000, 597.000 471.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-17/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-17/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-17/',
      },
      {
        points:
          '723.000 11.000, 884.000 11.000, 883.000 35.000, 886.000 36.000, 885.000 43.000, 883.000 44.000, 883.000 48.000, 885.000 49.000, 885.000 63.000, 883.000 64.000, 883.000 68.000, 885.000 69.000, 885.000 102.000, 884.000 122.000, 887.000 123.000, 887.000 135.000, 840.000 135.000, 840.000 129.000, 840.000 127.000, 824.000 127.000, 719.000 127.000, 719.000 123.000, 720.000 115.000, 722.000 115.000, 722.000 102.000, 721.000 102.000, 721.000 69.000, 723.000 69.000, 724.000 64.000, 721.000 64.000, 721.000 49.000, 724.000 49.000, 724.000 44.000, 721.000 43.000, 721.000 36.000, 723.000 35.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-18/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-18/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-18/',
      },
      {
        points:
          '723.000 198.000, 845.000 198.000, 845.000 124.000, 719.000 124.000, 719.000 137.000, 698.000 136.000, 699.000 139.000, 699.000 188.000, 723.000 187.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-19/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-19/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-19/',
      },
      {
        points:
          '846.000 195.000, 846.000 283.000, 723.000 283.000, 723.000 254.000, 699.000 255.000, 698.000 203.000, 722.000 205.000, 723.000 194.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-20/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-20/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-20/',
      },
      {
        points:
          '723.000 281.000, 846.000 281.000, 846.000 369.000, 729.000 369.000, 729.000 317.000, 722.000 317.000, 720.000 314.000, 720.000 281.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-21/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-21/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-21/',
      },
      {
        points:
          '729.000 541.000, 846.000 541.000, 846.000 629.000, 721.000 629.000, 721.000 595.000, 729.000 593.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-22/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-22/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-22/',
      },
      {
        points:
          '720.000 627.000, 846.000 627.000, 846.000 699.000, 720.000 699.000, 720.000 690.000, 699.000 690.000, 699.000 640.000, 720.000 640.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-23/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-23/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-23/',
      },
      {
        points:
          '720.000 697.000, 886.000 697.000, 886.000 723.000, 885.000 724.000, 885.000 755.000, 883.000 755.000, 882.000 761.000, 885.000 761.000, 885.000 775.000, 882.000 775.000, 882.000 781.000, 885.000 781.000, 885.000 788.000, 883.000 788.000, 884.000 814.000, 722.000 814.000, 723.000 789.000, 721.000 788.000, 721.000 781.000, 723.000 781.000, 724.000 776.000, 721.000 775.000, 721.000 761.000, 724.000 761.000, 723.000 755.000, 721.000 755.000, 721.000 720.000, 720.000 720.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-24/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-24/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-24/',
      },
      {
        points:
          '945.000 438.000, 945.000 318.000, 935.000 318.000, 935.000 295.000, 884.000 295.000, 884.000 302.000, 875.000 302.000, 875.000 439.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-25/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-25/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-25/',
      },
      {
        points:
          '942.000 439.000, 942.000 319.000, 952.000 319.000, 952.000 295.000, 1002.000 295.000, 1002.000 319.000, 1012.000 319.000, 1012.000 438.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-26/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-26/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-26/',
      },
      {
        points:
          '1009.000 319.000, 1009.000 439.000, 1079.000 439.000, 1079.000 319.000, 1069.900 319.000, 1069.900 295.000, 1019.000 295.000, 1019.000 319.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-27/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-27/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-27/',
      },
      {
        points:
          '875.000 472.000, 944.000 472.000, 945.000 592.000, 934.000 592.000, 934.000 616.000, 875.000 616.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-28/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-28/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-28/',
      },
      {
        points:
          '942.000 592.000, 952.000 592.000, 952.000 615.000, 1003.000 616.000, 1002.000 592.000, 1012.000 591.000, 1012.000 472.000, 942.000 472.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-29/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-29/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-29/',
      },
      {
        points:
          '1009.000 592.000, 1009.000 472.000, 1079.000 472.000, 1079.000 591.000, 1069.000 591.000, 1069.000 616.000, 1018.000 616.000, 1019.000 592.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-30/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-30/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-30/',
      },
      {
        points:
          '1075.000 592.000, 1076.000 472.000, 1146.000 472.000, 1145.000 591.000, 1136.000 591.000, 1136.000 616.000, 1086.000 616.000, 1086.000 592.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-31/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-31/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-31/',
      },
      {
        points:
          '1201.000 264.000, 1248.000 264.000, 1249.000 257.000, 1285.000 257.000, 1285.000 255.000, 1367.000 255.000, 1368.000 233.000, 1365.000 233.000, 1365.000 228.000, 1368.000 227.000, 1367.000 197.000, 1364.000 197.000, 1364.000 191.000, 1367.000 191.000, 1367.000 176.000, 1364.000 176.000, 1365.000 170.000, 1367.000 170.000, 1367.000 163.000, 1365.000 163.000, 1365.000 138.000, 1206.000 139.000, 1205.000 162.000, 1203.000 163.000, 1203.000 170.000, 1206.000 170.000, 1206.000 176.000, 1203.000 176.000, 1203.000 191.000, 1206.000 191.000, 1206.000 197.000, 1203.000 197.000, 1203.000 227.000, 1206.000 228.000, 1206.000 233.000, 1203.000 233.000, 1202.000 237.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-32/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-32/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-32/',
      },
      {
        points:
          '1243.000 325.000, 1243.000 252.000, 1367.000 252.000, 1367.000 266.000, 1383.000 266.000, 1383.000 316.000, 1365.000 316.000, 1357.000 317.000, 1357.000 322.000, 1357.000 325.000, 1246.000 325.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-33/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-33/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-33/',
      },
      {
        points:
          '1242.000 541.000, 1243.000 629.000, 1252.000 630.000, 1362.000 630.000, 1365.000 634.000, 1384.000 634.000, 1384.000 594.000, 1362.000 594.000, 1359.000 593.000, 1359.000 541.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-34/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-34/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-34/',
      },
      {
        points:
          '1243.000 627.000, 1361.000 627.000, 1365.000 634.000, 1369.000 634.000, 1369.000 640.000, 1388.000 640.000, 1388.000 689.000, 1362.000 689.000, 1362.000 699.200, 1243.000 699.200',
        pdf: 'https://centraljasna.sk/apartman-5-6np-35/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-35/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-35/',
      },
      {
        points:
          '1202.000 697.000, 1369.000 697.000, 1370.000 712.000, 1367.000 712.000, 1368.000 755.000, 1364.000 755.000, 1364.000 761.000, 1367.000 761.000, 1367.000 775.000, 1365.000 775.000, 1364.000 781.000, 1368.000 781.000, 1367.000 788.000, 1365.000 789.000, 1366.000 814.000, 1204.000 814.000, 1205.000 789.000, 1203.000 788.000, 1203.000 781.000, 1205.000 781.000, 1206.000 776.000, 1203.000 775.000, 1203.000 761.000, 1206.000 761.000, 1206.000 755.000, 1203.000 755.000, 1203.000 721.000, 1202.000 721.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-36/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-36/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-36/',
      },
      {
        points:
          '1357.000 318.000, 1357.000 438.000, 1464.000 438.000, 1464.000 374.000, 1487.000 374.000, 1487.000 324.000, 1466.000 324.000, 1466.000 315.000, 1440.000 314.000, 1441.000 294.000, 1390.000 295.000, 1390.000 319.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-37/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-37/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-37/',
      },
      {
        points:
          '1357.000 592.000, 1390.000 592.000, 1389.000 616.000, 1441.000 616.000, 1440.000 596.000, 1466.000 596.000, 1464.000 584.000, 1464.000 472.000, 1357.000 472.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-38/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-38/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-38/',
      },
      {
        points:
          '393.000 438.000, 463.000 438.000, 463.000 318.000, 452.900 318.000, 452.900 295.000, 403.000 295.000, 403.000 301.100, 394.000 301.100',
        pdf: 'https://centraljasna.sk/apartman-5-6np-39/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-39/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-39/',
      },
      {
        points:
          '460.000 319.000, 460.000 438.000, 530.000 438.000, 530.000 319.000, 520.000 319.000, 520.000 295.000, 470.000 295.000, 470.000 319.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-40/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-40/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-40/',
      },
      {
        points:
          '402.000 616.000, 453.000 616.000, 453.000 592.000, 463.000 592.000, 463.000 472.000, 393.000 472.000, 393.000 608.000, 403.000 608.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-41/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-41/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-41/',
      },
      {
        points:
          '470.000 592.000, 470.000 617.000, 520.000 616.000, 520.000 592.000, 531.000 592.000, 531.000 472.000, 460.000 472.000, 460.000 592.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-42/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-42/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-42/',
      },
      {
        points:
          '1213.000 439.000, 1144.000 439.000, 1144.000 319.000, 1153.000 319.000, 1153.000 295.000, 1204.000 295.000, 1204.000 302.000, 1214.000 302.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-43/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-43/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-43/',
      },
      {
        points:
          '1086.000 295.000, 1136.000 295.000, 1136.000 319.000, 1145.000 319.000, 1145.000 439.000, 1076.000 439.000, 1076.000 319.000, 1086.000 319.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-44/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-44/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-44/',
      },
      {
        points:
          '1143.000 472.000, 1143.000 592.000, 1153.000 592.000, 1153.000 616.000, 1213.000 616.000, 1214.000 471.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-45/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-45/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-45/',
      },
    ],
  },
  '6NP': {
    viewBox: '0 0 1493 927',
    maxZoom: 2.5,
    apartments: [
      {
        points: '24.000 463.000, 24.000 604.000, 132.000 601.000, 132.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-1/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-1/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-1/',
      },
      {
        points: '130.000 601.000, 130.000 465.000, 233.000 465.000, 233.000 601.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-2/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-2/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-2/',
      },
      {
        points:
          '24.000 325.000, 51.000 325.000, 51.000 331.000, 97.000 331.000, 98.000 327.000, 133.000 327.000, 131.000 465.000, 25.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-3/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-3/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-3/',
      },
      {
        points:
          '130.000 327.000, 129.000 464.000, 234.000 464.000, 234.000 328.000, 199.000 327.000, 198.000 331.000, 152.000 330.000, 152.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-4/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-4/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-4/',
      },
      {
        points:
          '225.000 45.000, 386.000 44.000, 384.000 137.000, 222.000 137.000, 222.000 135.000, 225.000 135.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-5/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-5/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-5/',
      },
      {
        points:
          '222.000 135.000, 222.000 149.000, 224.000 149.000, 225.000 208.000, 386.000 208.000, 385.000 135.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-6/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-6/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-6/',
      },
      {
        points:
          '225.000 204.000, 385.000 204.000, 385.000 317.000, 387.000 335.000, 381.000 335.000, 381.000 379.000, 315.000 379.000, 314.000 436.000, 271.000 437.000, 271.000 380.000, 261.000 379.000, 261.000 336.000, 230.000 335.000, 225.000 326.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-7/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-7/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-7/',
      },
      {
        points:
          '230.000 550.000, 382.000 550.000, 382.000 594.000, 386.000 638.000, 225.000 639.000, 225.000 634.000, 229.000 634.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-8/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-8/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-8/',
      },
      {
        points:
          '225.000 636.000, 386.000 636.000, 386.000 724.000, 225.000 724.000, 225.000 713.000, 228.000 712.000, 230.000 666.000, 225.000 666.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-9/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-9/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-9/',
      },
      {
        points:
          '225.000 722.000, 386.000 722.000, 384.000 794.000, 222.000 795.000, 222.000 781.000, 224.000 781.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-10/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-10/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-10/',
      },
      {
        points:
          '222.000 791.000, 384.000 791.000, 386.000 884.000, 375.000 883.000, 375.000 878.000, 235.000 879.000, 235.000 883.000, 223.000 883.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-11/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-11/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-11/',
      },
      {
        points:
          '704.000 327.000, 703.000 331.000, 656.000 331.000, 657.000 327.000, 644.000 327.000, 645.000 463.000, 714.000 463.000, 715.000 436.000, 756.000 436.000, 756.000 376.000, 715.000 375.000, 714.000 329.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-12/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-12/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-12/',
      },
      {
        points:
          '578.000 464.000, 578.000 327.000, 590.000 327.000, 590.000 332.000, 636.000 331.000, 637.000 327.000, 648.000 327.000, 647.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-13/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-13/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-13/',
      },
      {
        points:
          '510.000 327.000, 510.000 465.000, 580.000 464.000, 581.000 327.000, 569.000 327.000, 569.000 332.000, 522.000 332.000, 522.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-14/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-14/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-14/',
      },
      {
        points:
          '647.000 465.000, 714.000 465.000, 714.000 600.000, 704.000 600.000, 704.000 598.000, 656.000 598.000, 656.000 601.000, 644.000 601.000, 645.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-15/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-15/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-15/',
      },
      {
        points:
          '577.000 465.000, 577.000 602.000, 589.000 602.000, 589.000 598.000, 636.000 598.000, 637.000 601.000, 649.000 601.000, 647.000 464.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-16/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-16/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-16/',
      },
      {
        points:
          '511.000 465.000, 509.000 602.000, 515.000 602.000, 522.000 602.000, 522.000 598.000, 569.000 598.000, 569.000 601.000, 581.000 602.000, 580.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-17/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-17/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-17/',
      },
      {
        points:
          '703.000 138.000, 867.000 138.000, 867.000 112.000, 868.000 45.000, 706.000 45.000, 705.000 112.000, 707.000 113.000, 706.000 135.000, 703.000 135.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-18/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-18/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-18/',
      },
      {
        points: '704.000 134.000, 706.000 207.000, 868.000 208.000, 866.000 135.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-19/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-19/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-19/',
      },
      {
        points: '706.000 203.000, 706.000 294.000, 867.000 294.000, 868.000 204.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-20/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-20/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-20/',
      },
      {
        points:
          '706.000 290.000, 868.000 289.000, 869.000 334.000, 863.000 335.000, 861.000 378.000, 796.000 379.000, 796.000 436.000, 752.000 437.000, 752.000 379.000, 712.000 378.000, 712.000 335.000, 705.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-21/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-21/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-21/',
      },
      {
        points:
          '713.000 550.000, 862.000 549.000, 861.000 593.000, 867.000 593.000, 867.000 639.000, 706.000 638.000, 706.000 635.000, 710.000 634.000, 710.000 601.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-22/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-22/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-22/',
      },
      {
        points:
          '706.000 635.000, 868.000 636.000, 867.000 707.000, 704.000 709.000, 704.000 697.000, 710.000 697.000, 710.000 650.000, 706.000 649.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-23/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-23/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-23/',
      },
      {
        points:
          '704.000 705.000, 867.000 705.000, 868.000 797.000, 857.000 797.000, 857.000 793.000, 717.000 793.000, 717.000 798.000, 705.000 798.000, 707.000 709.000, 704.000 708.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-24/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-24/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-24/',
      },
      {
        points:
          '858.000 331.000, 917.000 331.000, 917.000 327.000, 929.000 327.000, 928.000 463.000, 858.000 463.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-25/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-25/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-25/',
      },
      {
        points:
          '926.000 463.000, 995.000 463.000, 996.000 327.000, 985.000 327.000, 983.000 332.000, 937.000 332.000, 937.000 327.000, 924.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-26/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-26/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-26/',
      },
      {
        points:
          '993.000 327.000, 992.000 465.000, 1062.000 465.000, 1063.000 327.000, 1051.000 327.000, 1051.000 332.000, 1004.000 332.000, 1004.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-27/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-27/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-27/',
      },
      {
        points:
          '858.000 463.000, 929.000 465.000, 930.000 601.000, 917.000 601.000, 916.000 598.000, 869.000 597.000, 869.000 602.000, 858.000 601.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-28/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-28/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-28/',
      },
      {
        points:
          '926.000 465.000, 996.000 465.000, 996.000 603.000, 992.000 603.000, 985.000 601.000, 984.000 598.000, 937.000 598.000, 937.000 601.000, 924.000 601.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-29/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-29/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-29/',
      },
      {
        points:
          '993.000 465.000, 992.000 602.000, 1003.000 601.000, 1003.000 598.000, 1050.000 598.000, 1052.000 601.000, 1059.000 601.000, 1063.000 601.000, 1063.000 593.000, 1064.000 490.000, 1062.000 490.000, 1063.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-30/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-30/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-30/',
      },
      {
        points:
          '1060.000 465.000, 1059.000 601.000, 1070.000 601.000, 1071.000 598.000, 1118.000 598.000, 1118.000 601.000, 1130.000 602.000, 1129.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-31/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-31/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-31/',
      },
      {
        points:
          '1188.000 172.000, 1199.000 172.000, 1199.000 177.000, 1338.000 177.000, 1339.000 172.000, 1349.000 172.000, 1349.000 261.000, 1351.000 264.000, 1188.000 265.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-32/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-32/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-32/',
      },
      {
        points:
          '1188.000 261.000, 1352.000 262.000, 1351.000 278.000, 1345.000 279.000, 1345.000 332.000, 1327.000 333.000, 1326.000 379.000, 1241.000 378.000, 1241.000 334.000, 1188.000 334.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-33/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-33/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-33/',
      },
      {
        points:
          '1192.000 550.000, 1343.000 550.000, 1343.000 594.000, 1349.000 594.000, 1349.000 638.000, 1188.000 638.000, 1188.000 601.000, 1186.000 594.000, 1192.000 594.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-34/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-34/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-34/',
      },
      {
        points:
          '1188.000 636.000, 1349.000 636.000, 1349.000 697.000, 1352.000 697.000, 1351.000 708.000, 1188.000 708.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-35/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-35/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-35/',
      },
      {
        points:
          '1188.000 705.000, 1351.000 705.000, 1351.000 708.200, 1348.000 709.000, 1348.000 797.000, 1339.000 797.000, 1339.000 791.900, 1199.000 791.900, 1199.000 797.000, 1188.000 797.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-36/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-36/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-36/',
      },
      {
        points:
          '1340.000 463.000, 1448.000 465.000, 1448.000 368.000, 1444.000 368.000, 1444.000 334.000, 1448.000 335.000, 1448.000 325.000, 1423.000 325.000, 1422.000 331.000, 1374.000 331.000, 1374.000 327.000, 1340.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-37/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-37/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-37/',
      },
      {
        points:
          '1340.000 465.000, 1340.000 601.000, 1375.000 601.000, 1375.000 598.000, 1422.000 598.000, 1422.000 604.000, 1449.000 604.000, 1448.000 594.000, 1448.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-38/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-38/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-38/',
      },
      {
        points:
          '377.000 331.000, 435.000 332.000, 435.000 327.000, 447.000 327.000, 447.000 465.000, 377.000 463.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-39/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-39/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-39/',
      },
      {
        points:
          '444.000 327.000, 444.000 464.000, 514.000 464.000, 514.000 327.000, 502.000 327.000, 501.000 332.000, 455.000 331.000, 456.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-40/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-40/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-40/',
      },
      {
        points:
          '377.000 465.000, 377.000 598.000, 388.000 597.000, 435.000 597.000, 435.000 601.000, 446.000 601.000, 446.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-41/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-41/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-41/',
      },
      {
        points:
          '444.000 465.000, 443.000 601.000, 455.000 601.000, 455.000 598.000, 502.000 598.000, 503.000 602.000, 514.000 602.000, 513.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-42/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-42/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-42/',
      },
      {
        points:
          '1127.000 327.000, 1126.000 463.000, 1197.000 463.000, 1197.000 378.000, 1230.000 379.000, 1229.000 332.000, 1186.000 332.000, 1139.000 332.000, 1139.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-43/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-43/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-43/',
      },
      {
        points:
          '1059.000 327.000, 1059.000 465.000, 1130.000 465.000, 1130.000 327.000, 1118.000 327.000, 1117.000 333.000, 1071.000 332.000, 1071.000 327.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-44/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-44/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-44/',
      },
      {
        points:
          '1126.000 465.000, 1127.000 601.000, 1137.000 601.000, 1138.000 598.000, 1185.000 598.000, 1196.000 597.000, 1197.000 465.000',
        pdf: 'https://centraljasna.sk/apartman-5-6np-45/',
        reserved: true,
        sold: true,
        en: 'https://centraljasna.sk/en/suite-5-6th-floor-45/',
        pl: 'https://centraljasna.sk/pl/apartament-5-6-pietro-45/',
      },
    ],
  },
};
